export default __webpack_public_path__ + "static/media/icon-package.7b435451.svg";